<template>
    <div class="biz-home parent-frame">
        <div class="biz-home-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    }
}
</script>
<style lang="scss">
    .biz-home{
        position: relative;
        .biz-home-wrap{
            padding: 0 30px 30px 30px;
            width:  calc(1180px - 40px);
        }
    }
    @media screen and (max-width: 1280px){
        .biz-home{
            .biz-home-wrap{
                width:  1140px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/personalHome/homeFrame.vue